/**
 * Emit hosts for the `pyne` analytics group — 1 function
 * lifted out of `analyticsScribeModel`'s effects so a call site can emit
 * without holding a Rematch `dispatch`. Every payload is the effect's own.
 */
import { trackLegacyEvent } from '@/lib/analytics/track-legacy-event';
import { SegmentActionName, SegmentObjectName } from '@/models/analytics/segment-names';

export function trackPyneOnboardingRendered(input: { region: string }) {
  const { region } = input;
  trackLegacyEvent({
    name: SegmentObjectName.Pyne,
    props: {
      action: SegmentActionName.OnboardingFlowRendered,
      region,
    },
  });
}
